export default "__VITE_PUBLIC_ASSET__3ab133bf__"